var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.18 19.07c-1.678-2.908-.668-6.634 2.256-8.328L28.29 5.295a6.017 6.017 0 0 1-3.057.83c-3.36 0-6.085-2.743-6.085-6.126h-6.29a5.998 5.998 0 0 1-.81 3.07c-1.68 2.907-5.41 3.896-8.34 2.21L.566 10.727a6.016 6.016 0 0 1 2.246 2.234c1.677 2.904.673 6.624-2.24 8.32l3.145 5.447a6.022 6.022 0 0 1 3.044-.82c3.35 0 6.066 2.725 6.083 6.092h6.29a6.03 6.03 0 0 1 .81-3.04c1.676-2.902 5.4-3.893 8.325-2.218l3.145-5.447a6.024 6.024 0 0 1-2.232-2.226zM16 22.48a6.481 6.481 0 0 1 0-12.96 6.481 6.481 0 0 1 0 12.96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingGear);
export default ForwardRef;